import { render, staticRenderFns } from "./ParcelaEnvioEmail.vue?vue&type=template&id=df684228&scoped=true"
import script from "./ParcelaEnvioEmail.vue?vue&type=script&lang=js"
export * from "./ParcelaEnvioEmail.vue?vue&type=script&lang=js"
import style0 from "./ParcelaEnvioEmail.vue?vue&type=style&index=0&id=df684228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df684228",
  null
  
)

export default component.exports